/**
 * Validates a password according to the application's password requirements
 * @param {string} password - The password to validate
 * @param {string} [confirmPassword] - Optional confirm password to validate against
 * @returns {{isValid: boolean, error: string|null}} - Validation result with error translation key
 */
export const validatePassword = (password, confirmPassword = null) => {
  const minNumberOfChars = 14;
  const maxNumberOfChars = 25;
  const regularExpression = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{14,25}$/;

  if (!password || password.trim() === '') {
    return {
      isValid: false,
      error: 'validation.passwordRequired',
    };
  }

  if (
    password.length < minNumberOfChars ||
    password.length > maxNumberOfChars
  ) {
    return {
      isValid: false,
      error: 'validation.passwordLength',
    };
  }

  if (!regularExpression.test(password)) {
    return {
      isValid: false,
      error: 'validation.passwordComplexity',
    };
  }

  if (confirmPassword !== null) {
    if (confirmPassword === '') {
      return {
        isValid: false,
        error: 'validation.confirmPasswordRequired',
      };
    }

    if (confirmPassword !== password) {
      return {
        isValid: false,
        error: 'validation.passwordMismatch',
      };
    }
  }

  return {
    isValid: true,
    error: null,
  };
};
